export default {
  order_again: 'Opnieuw bestellen',
  error_messages: {
    product_does_not_exist: 'Het product is niet meer beschikbaar',
  },
  success_messages: {
    product_added_to_card: 'Product toegevoegd aan winkelwagen',
  },
};
